/** Split the battle roll from its description and loss summary for native layout. */
export function splitLogDiceComparison(text: string) {
  const match = /((?:\[\d{1,2}\][ \t]*)+)vs[ \t]+((?:\[\d{1,2}\][ \t]*)+)/.exec(text)
  if (!match) return null
  const before = text.slice(0, match.index).trimEnd()
  return {
    description: /^\d+\.$/.test(before) ? '' : before,
    prefix: /^\d+\.$/.test(before) ? before : '',
    attacker: match[1]!.trim(),
    defender: match[2]!.trim(),
    suffix: text.slice(match.index + match[0].length).trim(),
  }
}
